<div
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (dragenter)="onDragEnter($event)"
    class="relative flex flex-column h-full relative"
>
    <div class="conversation">
        <app-chat-main-conversation></app-chat-main-conversation>
    </div>
    <div class="prompt flex justify-content-center">
        <app-chat-main-prompt
            class="flex align-items-center prompt-component">
        </app-chat-main-prompt>
    </div>

    <div
        *ngIf="!disableAddFileEvent()"
        [class.file-over]="isFileOver"
        class="file-drop"
    >
        <div class="drop-text w-full h-full flex align-items-center flex-column justify-content-center">
            <i class="block pi pi-file" style="font-size: 5rem; opacity: 0.4"></i>
            <span class="block mt-3">Drop file here to add the conversation</span>
        </div>
    </div>

    <ng-container *ngIf="showSpinner">
        <app-spinner [spinnerPosition]="SpinnerPosition.Absolute"></app-spinner>
    </ng-container>
</div>
